import { render, staticRenderFns } from "./CreatePostHelp.vue?vue&type=template&id=53d568d6&scoped=true&"
var script = {}
import style0 from "./CreatePostHelp.vue?vue&type=style&index=0&id=53d568d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d568d6",
  null
  
)

export default component.exports